import React from "react";
import "./styles/SummaryDescription.scss";

export default (props) => (
  <p className="summary-description">{props.children}</p>
);
